import { initNetworkManager, addInterceptors } from '@tencent/iegsp-common/request';
import { LoginInfoInterceptor } from './loginInfoInterceptor';
import { MessageInterceptor } from './messageInterceptor';

addInterceptors('responseInterceptors', [new LoginInfoInterceptor()]);
addInterceptors('responseInterceptors', [new MessageInterceptor()]);

export { initNetworkManager };
